'use client';

import { Grid } from '@mui/material';
import React, { memo } from 'react';
import { ThemeProvider } from '../../styles/theme-config/ThemeProvider';
import Banner from './Banner';

/**
 * @name BannerContainer
 * @param {*} props - Strapi Data
 * @returns {JSX.Element} - Renders Banner component
 */
const BannerContainer = props => (
  <>
    <ThemeProvider palette={props?.cmsData?.Banner_theme?.theme}>
      <Grid container>
        <Banner
          cmsData={props?.cmsData}
          handleAction={props.handleAction}
          secondBanner={props?.isSecondBanner}
        />
      </Grid>
    </ThemeProvider>
  </>
);

BannerContainer.displayName = 'BannerContainer';
export default memo(BannerContainer);
